import * as React from 'react'
import parse from 'html-react-parser';
import moment from 'moment'
import { GatsbyImage } from "gatsby-plugin-image"

function array_union(array1, array2) {
    var concat_array = array1.concat(array2);

    // create Set, eliminate duplicates
    var set_ob = new Set(concat_array);

    // final array that holds union
    var array_union = [];

    // iterate through each element of Set
    // push each element into final array
    for(var element of set_ob) {    
        array_union.push(element); 
    }

    return array_union;

}
/**
 * Shuffle an array using the Fisher-Yates algorithm
 * */
function array_shuffle(arr) {
    let arr_copy = Array.from(arr);

    // Start from the last element and swap
    // one by one. We don't need to run for
    // the first element that's why i > 0
    for (let i = arr_copy.length - 1; i > 0; i--) {
        // pick a random index from 0 to i inclusive
        const j = Math.floor(Math.random() * (i + 1)); // at random index
        // Swap arr[i] with the element
        [arr_copy[i], arr_copy[j]] = [arr_copy[j], arr_copy[i]];
    }

    return arr_copy;
}

function sort_node_title(list) {
    const comparison = function(a, b) {
        if (a.node.title === b.node.title) {
            return 0;
        }

        return a.node.title > b.node.title
    }

    return list.sort(comparison);
}


function getMetadata() {
	try {
		var data = require('/config/sites/library.js');
		return data;
	} catch (e) {
		if (e instanceof Error && e.code === "MODULE_NOT_FOUND") {
			console.log("Can't load metadata");
		} else {
			throw e;
		}
	}
	
	return null;
}

function getURL() {
	const metadata = getMetadata();
	return metadata['url'];
}

/**
 * Given a relative path, get a fully qualified URL.
 * @param {string} path The relative path.
 * @returns 
 */
function getAbsoluteLink(path) {
    const url = getURL();
    return `${url}${path}`;
}

/**
 * Get a value from an object using the provided path. 
 * If the path does not exist in the object, return default_value (null by default).
 * @param {object} data 
 * @param {string} path 
 * @param {*} default_value 
 * @returns 
 */
function get_optional_field(data, path, default_value = null) {
    if (!data) return default_value;
    if (!path) return data;
    const properties = path.split('.');
    return get_optional_field(data[properties.shift()], properties.join('.'))
}

function get_labelled_field(value, label) {
    if (value) {
        return (
            <>
                {label}
                <div className="field-value" dangerouslySetInnerHTML={{__html: value}} />
            </>
        )
    }
}

function format_date(date, format='dddd, MMMM D, Y') {
    return moment(date).format(format);
}

/**
 * This replaces inline-images uploaded through CKEditor in the body field with Gatsby Images. 
 * See: https://www.andrewl.net/article/gatsby-drupal-inline-images
 * 
 * @param {*} body Processed body field from Drupal
 * @param {*} files Results of the graphql query: 
 * 
 *  files: allFileFile {
 *			edges {
 * 				node {
 *					localFile {
 *						childImageSharp {
 *							gatsbyImageData
 *						}
 *					}
 *					filesize
 *					filename
 *					filemime
 *					drupal_id
 *					uri {
 *						url
 *						value
 *					}
 *				}
 *			}
 *		}
 */
function process_inline_images(body, files) {
    const processed_body = new parse(body, {
		replace: function transform(node) {
			if (node.type === 'tag' && node.name === 'img') {
				const alt = node.attribs['alt'];
				const uuid = node.attribs["data-entity-uuid"];

                let classes = "";
                if (node.attribs["class"]) {
                    classes = node.attribs["class"];
                }

				let i = 0;
				for (i = 0; i < files.edges.length; i++) {
					const file = files.edges[i];
					if (file.node.drupal_id === uuid && file.node.localFile) {
						return <GatsbyImage className={classes} alt={alt} image={file.node.localFile.childImageSharp.gatsbyImageData}/>
					}
				}
			}
	  
			return undefined;
		}
	});

    return processed_body;
}

export {
    array_shuffle,
    sort_node_title,
    array_union,
    getMetadata,
    getURL,
    getAbsoluteLink,
    get_optional_field,
    get_labelled_field,
    format_date,
    process_inline_images
}